import { render, staticRenderFns } from "./AutomatedMessage.vue?vue&type=template&id=5018a76e&scoped=true&"
import script from "./AutomatedMessage.vue?vue&type=script&lang=js&"
export * from "./AutomatedMessage.vue?vue&type=script&lang=js&"
import style0 from "./AutomatedMessage.vue?vue&type=style&index=0&id=5018a76e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5018a76e",
  null
  
)

export default component.exports